import { reportSlugs } from '@app/ccf/company-report/slugs';
import ReportContent from '@app/components/reports/components/report-content';
import ReportMetric from '@app/components/reports/components/report-metric';
import SimpleBarChart from '@shared/components/chart/simple-bar-chart';
import Text from '@shared/components/content/text';
import { ChartConfig } from '@shared/components/ui/chart';
import { useCCFReportResult } from '../../ccf-report-result-context';

export default function MobileCombustion() {
  const {
    result: { scope1 },
  } = useCCFReportResult();

  const mobileCombustion = scope1.categories.find(
    (category) => category.slug === reportSlugs.mobileCombustion
  );

  const data = {
    mobile_combustion_emissions: mobileCombustion?.totalCategoryEmissionsTonnes,
    share_of_scope_emissions: mobileCombustion?.pctOfScopeEmissions,
    share_of_total_emissions: mobileCombustion?.pctOfCompanyEmissions,
    highest_emissions_fuels: mobileCombustion?.highestEmissionActivities.map(
      (fuel) => {
        return {
          fuel: fuel.name,
          emissions: fuel.emissionsTonnes,
          fill: 'var(--chart-3)',
        };
      }
    ),
  };

  const chartConfig = {
    emissions: {
      label: 'Emissions',
      color: 'hsl(var(--chart-1))',
      unit: 'tCO2e',
    },
  } satisfies ChartConfig;

  return (
    <ReportContent>
      <>
        <Text variant="reportBody">
          Mobile combustion is the burning of fuels such as diesel, petrol or
          biodiesel in vehicles your company has operational control over —
          those where your company pays for the fuel, whether owned or leased
          long-term.
        </Text>
        <ReportMetric
          title="Category emissions"
          value={data.mobile_combustion_emissions!}
          unit="tCO2e"
          size="lg"
        />
        <div className="flex space-x-2">
          <ReportMetric
            title="Share of Scope 1 emissions"
            value={data.share_of_scope_emissions!}
            unit="%"
            size="md"
            className="flex-1"
          />
          <ReportMetric
            title="Share of total emissions"
            value={data.share_of_total_emissions!}
            unit="%"
            size="md"
            className="flex-1"
          />
        </div>
      </>
      <>
        <Text variant="h3">Highest emissions fuels</Text>
        <SimpleBarChart
          nameKey="fuel"
          dataKey="emissions"
          chartData={data.highest_emissions_fuels}
          chartConfig={chartConfig}
          className="h-min max-h-[calc(var(--content-title-height)-15rem)] w-full"
          layout="vertical"
          margin={{ right: 80 }}
          XAxisProps={{
            label: {
              value: 'tCO2e',
              position: 'right',
              offset: 20,
            },
          }}
        />
      </>
    </ReportContent>
  );
}
